import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Login.css';

const API = 'https://bacmt.com.ar';
/*const API = 'http://192.168.2.25:3000';*/

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [form, setForm] = useState({ password: '', confirmar: '' });
  const [error, setError]   = useState('');
  const [exito, setExito]   = useState('');
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('Link inválido. Solicitá uno nuevo desde el login.');
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setExito('');
    if (form.password !== form.confirmar) { setError('Las contraseñas no coinciden'); return; }
    if (form.password.length < 6) { setError('La contraseña debe tener al menos 6 caracteres'); return; }
    setCargando(true);
    try {
      const res = await axios.post(`${API}/api/auth/reset-password`, {
        token, password: form.password
      });
      setExito(res.data.mensaje);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al restablecer la contraseña');
    } finally { setCargando(false); }
  };

  return (
    <div className="login-fondo">
      <div className="login-panel-izq">
        <div className="login-panel-contenido">
          <img src="/img/BAC-MT.png" alt="BAC MT" className="login-img" />
          <h1 className="login-panel-titulo">BAC MT</h1>
          <p className="login-panel-desc">
            Plataforma de monitoreo en tiempo real para su dispositivo de
            marcación y control de Kits empleados en estudios cardiológicos y neurológicos.
          </p>
        </div>
      </div>

      <div className="login-panel-der">
        <div className="login-card">
          <p className="login-card-sub">NUEVA CONTRASEÑA</p>
          <p style={{ fontSize: '0.83rem', color: 'var(--text-muted)', marginBottom: '20px', lineHeight: '1.5' }}>
            Ingresá tu nueva contraseña. Tiene que tener al menos 6 caracteres.
          </p>

          {!token ? (
            <div className="login-error">⚠ Link inválido o expirado. <button className="login-link-btn" onClick={() => navigate('/login')}>Volver al login</button></div>
          ) : (
            <form onSubmit={handleSubmit} className="login-form">
              <div className="login-campo">
                <label className="login-label">Nueva contraseña</label>
                <input type="password" value={form.password}
                  onChange={e => setForm({...form, password: e.target.value})}
                  placeholder="Mínimo 6 caracteres" className="login-input" required />
              </div>
              <div className="login-campo">
                <label className="login-label">Confirmar contraseña</label>
                <input type="password" value={form.confirmar}
                  onChange={e => setForm({...form, confirmar: e.target.value})}
                  placeholder="Repetí la contraseña" className="login-input" required />
              </div>
              {error && <div className="login-error">⚠ {error}</div>}
              {exito && (
                <div className="login-exito">
                  ✓ {exito} — Redirigiendo al login...
                </div>
              )}
              {!exito && (
                <button type="submit" className="login-btn" disabled={cargando}>
                  {cargando ? 'Guardando...' : 'Guardar nueva contraseña'}
                </button>
              )}
            </form>
          )}

          <p className="login-footer">Copyright © 2026 Laboratorios Bacon</p>
        </div>
      </div>
    </div>
  );
}

export default ResetPassword;